import { render, staticRenderFns } from "./StockViewPurchaseOrder.vue?vue&type=template&id=13d1449b&scoped=true"
import script from "./StockViewPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./StockViewPurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./StockViewPurchaseOrder.vue?vue&type=style&index=0&id=13d1449b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d1449b",
  null
  
)

export default component.exports